<template>
	<div>
		<OkCancelDialog ref="dlgOkCancel" @actionOk='() => { redirectToDescargarDocumentacion(); }' :btnOk="btnOk"
			:titulo="tituloModal" :textInfo1="textInfoModal1" :textInfo2="textInfoModal2">
		</OkCancelDialog>
		<v-row>
			<v-col v-if="!isLoading" class="mx-auto" cols="12" md="10" lg="9">
				<v-alert color="#124D91" text>
					<img src="../assets/mano.svg"
						style="margin: 0 25px 0 10px; float: left; height: 50px !important;" />
					<span class="d-flex align-center flex-wrap"
						style="color: #595959; font-size: 16px; line-height: 50px;">
						En este formulario gestionarás el expediente &nbsp;<b>{{ referenciaSolicitante.numeroReferencia
						}}</b>,
						del trabajador con NIF
						&nbsp;<b>{{ referenciaSolicitante.dni }}</b>
					</span>
				</v-alert>
			</v-col>

			<v-col class="mx-auto" cols="12" md="10" lg="9">
				<v-card outlined>
					<v-list-item>
						<v-list-item-content>
							<v-list-item-title class="umivale-headline mb-1">Identificación</v-list-item-title>
							<v-list-item-subtitle style="white-space: inherit;">Proporcione algunos datos del expediente
								para iniciar este trámite
							</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>

					<v-card-text>
						<v-skeleton-loader v-if="isLoading" type="card" class="mb-4 mx-auto" max-width="90%" />
						<v-row>
							<v-col class="mx-auto" cols="12" sm="10" md="8">
								<v-form v-if="!isLoading" ref="validateForm" style="min-height: 150px">
									<v-row>
										<v-col cols="12" sm="6" md="6">
											<v-text-field outlined v-model="usuario.dni" readonly label="DNI o NIE" />
										</v-col>

										<v-col cols="12" sm="6" md="6">
											<v-text-field outlined v-model="unmaskedNASS" v-mask="' ##/########/##'"
												autocomplete="off"
												:rules="[validationRules.required, validationRules.nass]"
												label="NAF (Número de afiliación de la TGSS)"
												hint="Si su NAF tiene 7 dígitos, añada uno al inicio."
												persistent-hint />
											<span class="ml-3">Ejemplo: 11/01234567/22
											</span><br>
											<span><a class="btn-link ml-3" @click="verAyudaNAF()">
													¿Dónde puedo encontrar mi NAF?
												</a>
											</span>
										</v-col>
									</v-row>

									<v-row style="margin: 30px 0; text-align:center; margin: 12px auto;">
										<v-col cols="12" class="d-flex justify-center mx-auto">
											<v-btn class="btn-next" :disabled="isLoading" @click="validate"
												color="primary">
												Acceder
											</v-btn>
										</v-col>
									</v-row>

								</v-form>
							</v-col>
						</v-row>
					</v-card-text>

					<v-row class="mb-6">
						<v-col v-if="!isLoading && mostrarAviso" class="mx-auto" cols="11">
							<v-alert color="#D92727" text>
								<img alt="warning" src="../assets/warning_rojo.svg" height="30px"
									style="margin: 10px 25px 0 10px; float: left;" />
								<span
									style="color: #595959; font-size: 1em; padding-left: 72px; display: block;"><strong>No
										encontramos ningún expediente asociado a los datos introducidos</strong><br>
									Por favor, asegúrese de que son correctos.<br>Si son correctos, contacte en el 900
									365
									012
									con nuestro servicio de atención al cliente.</span>
							</v-alert>
						</v-col>
					</v-row>

					<!-- expediente bloqueado -->
					<v-row>
						<v-col v-if="!isLoading && mostrarAvisoExpedienteBloqueado" class="mx-auto" cols="11">
							<v-alert color="#D92727" text>
								<img alt="warning" src="../assets/warning_rojo.svg" height="30px"
									style="margin: 10px 25px 0 10px; float: left;" />
								<span
									style="color: #595959; font-size: 1em; padding-left: 72px; display: block;"><strong>No
										es posible el acceso</strong>
									<br>
									El expediente se encuentra bloqueado.
								</span>
							</v-alert>
						</v-col>
					</v-row>

				</v-card>
			</v-col>
			<AyudaNAFDialog ref="dlgAyudaNAF" />
		</v-row>

	</div>
</template>

<script>
import api from '@Base/services/solicitudService'
import { mask } from 'vue-the-mask'
import StepBase from '@Base/pages/common/StepBase.js'
import AyudaNAFDialog from '@Base/pages/common/AyudaNAFDialog'
import OkCancelDialog from '@Base/pages/common/OkCancelDialog'
import { routeNameAfterLogin } from '@Base/utils/helpers'

export default {
	name: 'ValidarUsuario',
	components: {
		AyudaNAFDialog, OkCancelDialog
	},
	directives: { mask },
	mixins: [StepBase],
	data() {
		return {
			btnOk: "Acceder al gestor documental",
			textInfoModal1: 'Lo sentimos, pero parece que la notificación a la que intenta acceder ha caducado.',
			textInfoModal2: '¿Desea acceder al gestor documental?',
			tituloModal: 'Notificación caducada',
			isLoading: false,
			tokenGestion: null,
			datePickerMenu: false,
			idNotificacionOrigen: null,
			revision: null,
			unmaskedNASS: null,
			mostrarAviso: false,
			mostrarAvisoExpedienteBloqueado: false,
			// expedienteBloqueado: false,
			usuario: {
				dni: null,
				nass: null,
				token: null
			},
			referenciaSolicitante: {
				dni: null,
				numeroReferencia: null,
			}
		}
	},
	watch: {
		$route(to) {
			this.mostrarAviso = false;
			this.$store.commit('solicitud/setSolicitante', null);
			this.$store.commit('solicitud/setTokenAcceso', null);
			this.$store.commit('solicitud/setTokenGestion', null);
			this.$store.commit('solicitud/setTituloModulo', 'Prestación extraordinaria por cese de actividad');
			this.$store.commit('solicitud/setPasoActual', 1);
			this.usuario.token = to.params.id;
			this.idNotificacionOrigen = to.params.notificacion;
			this.$store.commit('solicitud/SET_ID_NOTIFICACION', this.idNotificacionOrigen);
			this.getSolicitante(this);
			if (!to.params.id) {
				this.$router.push({ name: 'no-direct-access' });
			}
		},
	},
	beforeRouteEnter(to, from, next) {
		next(vm => {

			vm.$store.commit('solicitud/setTituloModulo', 'Prestación extraordinaria por cese de actividad');
			vm.$store.commit('solicitud/setPasoActual', 1);

			if (vm.$route.name == 'complete-redirect') {
				vm.isLoading = true;
				vm.usuario.token = vm.$store.state.solicitud.tokenAcceso;
				vm.idNotificacionOrigen = vm.$store.state.solicitud.idNotificacion
				vm.getEstadoActualizado(vm,
					() => vm.compruebaNotificacionPendiente());
				return;
			}
			vm.mostrarAviso = false;
			vm.$store.commit('solicitud/setSolicitante', null);
			vm.$store.commit('solicitud/setTokenAcceso', null);
			vm.$store.commit('solicitud/setTokenGestion', null);
			vm.$store.commit('solicitud/SET_ID_NOTIFICACION', to.params.notificacion);
			vm.usuario.token = to.params.id;
			vm.idNotificacionOrigen = to.params.notificacion;
			vm.getSolicitante(vm);
			if (!to.params.id) {
				vm.$router.push({ name: 'no-direct-access' });
			}
		})
	},
	methods: {
		routeNameAfterLogin,
		verAyudaNAF: function () {
			this.$refs.dlgAyudaNAF.open();
		},
		validate: function () {
			if (!this.$refs.validateForm.validate()) {
				return;
			}

			this.usuario.dni = this.usuario.dni.toUpperCase();
			this.usuario.nass = this.unmaskedNASS.replace(/[^0-9]/g, '');

			this.isLoading = true;
			this.mostrarAviso = false;
			// this.expedienteBloqueado = false

			api.validateUser(this.usuario,
				res => {
					this.tokenGestion = res;

					if (this.tokenGestion != null && this.tokenGestion !== "") {
						this.$store.commit('solicitud/setTokenGestion', this.tokenGestion);
						this.compruebaExpedienteBloqueado();
						return;
					}

					this.isLoading = false;
					this.mostrarAviso = true;
				},
				error => {
					this.isLoading = false;
					this.$emit('alert-event', { text: 'Error al validar el usuario', color: 'red' });
					console.log(error);
				});
		},
		getSolicitante(vm) {
			vm.isLoading = true;
			vm.mostrarAviso = false;

			api.getSolicitante(vm.usuario.token,
				res => {
					if (!res) {
						vm.isLoading = false;
						vm.mostrarAviso = true;
						return;
					}

					vm.isLoading = false;
					vm.referenciaSolicitante = res;
					vm.usuario.dni = res.dni;
					vm.unmaskedNASS = '';

					vm.$store.commit('solicitud/setTotalNotificaciones', 0);
					vm.$store.commit('solicitud/setSolicitante', res);
					vm.$store.commit('solicitud/setTokenAcceso', vm.usuario.token);
					this.getEstadoActualizado(vm)
				},
				error => {
					vm.isLoading = false;
					vm.$emit('alert-event', { text: 'Error al obtener el solicitante', color: 'red' });
					console.log(error);
				});
		},

		getEstadoActualizado(vm, callback) {
			const idSolicitud = vm.$store.state.solicitud.solicitante.idSolicitante;
			api.getEstadoActualizado(idSolicitud,
				data => {
					if (data) {
						vm.$store.commit('solicitud/setEstadoExpedienteActualizado', data);
					}
					if (callback) {
						callback();
					}
				},
				error => {
					this.$emit('alert-event', { text: 'Error al obtener el estado de la solicitud', color: 'red' });
					console.log(error);
				})
		},

		// Comprueba si el expediente está bloqueado. Si está bloqueado redirige al gestor documental, de lo contrario, comprueba si hay notificaciones pendientes.
		compruebaExpedienteBloqueado() {
			const idSolicitud = this.$store.state.solicitud.solicitante.idSolicitante;

			api.verificarExpedienteBloqueado(idSolicitud,
				resExpedienteBloqueado => {
					// Devuelve false si el objeto resExpedienteBloqueado está vacío, de lo contrario, devuelve true
					const expedienteBloqueado =
						resExpedienteBloqueado &&
							typeof resExpedienteBloqueado === 'object' &&
							Object.keys(resExpedienteBloqueado).length > 0
							? true
							: false;

					if (expedienteBloqueado) {
						this.isLoading = false;
						this.redirectToDescargarDocumentacion()

					} else if (!expedienteBloqueado) {
						this.compruebaNotificacionPendiente()
					}
				},
				error => {
					this.isLoading = false;
					this.$emit('alert-event', { text: 'Error al comprobar si expediente bloqueado', color: 'red' });
					console.log(error);
				});
		},

		compruebaNotificacionPendiente() {
			const idSolicitante = this.$store.state.solicitud.solicitante.idSolicitante;

			api.getNotificacionPendiente(
				this.idNotificacionOrigen,
				res => {
					const audFirma = res;
					this.isLoading = false;
					//Comprobamos el endpoint /pendiente devuelve notificaciones
					if (audFirma && audFirma.idFirmaDocumento) {
						const target = this.usuario.token;
						// Si el parámetro 'idNotificacion' de la URL tiene valor null, asignamos el valor devuelto por el endpoint 'audFirma.idFirmaDocumento' a 'idNotificacionOrigen'. En caso contrario, si en la URL tenemos el id de la notificaión, guardamos este valor en 'idNotificacionOrigen'
						this.idNotificacionOrigen = !this.idNotificacionOrigen ? audFirma.idFirmaDocumento : this.idNotificacionOrigen
						this.$store.commit('solicitud/setTotalNotificaciones', 1);
						this.$store.commit('solicitud/SET_AUD_FIRMA', audFirma)
						// 'routerName' contiene la ruta a la que se dirigirá más adelante, basándose en el tipo de documento recuperado en el endpoint
						const routeName = routeNameAfterLogin(audFirma.tipoDocumento);

						// Sirve para redirigir siempre a la 98,902,998. Es decir si recuperamos pendiente una 99, el idNotificacion hará referencia a la 98 (para la url)
						// solo sirve para que en caso de que sea una 99, recupere como id el de la 98
						const notificacionPendiente = !audFirma.notificacionOrigen ? audFirma.idFirmaDocumento : audFirma.notificacionOrigen;

						/*
						CASO 1: 
							- Entro sin idNotificacion en la url. La pendiente(audFirma) recupera un tipo 99(this.idNotificacionOrigen). notificacionPendiente = audFirma.notificacioOrigen. this.notificacionOrgien !== notificacionPendiente
								*Seteamos en el store el idNotificacion de notificacionPendiente(Es decir el de la 98). ***OK***
						CASO 2:
							- Entro sin idNotificacion en la url. La pendiente(audFirma) recupera un tipo 98(this.idNotificacionOrigen). notificacionPendiente = audFirma.idFirmaDocumento. this.notificacionOrgien === notificacionPendiente
								En caso de dos notificaciones activas, debe devolver la que tiene el ML_ENVIO más reciente. FUNCIONA CORRECTAMENTE ***OK***
						CASO 3:
							- Entro sin idNotificacion en la url. /pendiente devuelve null. NO SE CONTEMPLA DENTRO DE ESTE CONDICIONAL
							- Redireccion a Gestor Documental ***OK***
						CASO 4:
							- Entro con idNotificacion en la url. /pendiente devuelve un registro diferente al idNotificacion de mi url. Es decir, la notificacion a la que intento acceder ya no esta disponible.
							DEBO DE IR AL GESTOR DOCUMENTAL. AHORA MSIMO SE ESTÁ ENVIANDO A LA PROXIMA DISPONIBLE AUNQUE NO SEA LA DE ESE ENLACE.(NO DEBERÍA SER ASÍ) ***OK***
						CASO 5:
							- Entro con idNotificacion en la url. /pendiente devuelve un registro igual al idNotificacion de mi url. Es decir, la notificacion a la que intento acceder SI QUE ESTA DISPONIBLE.
							***OK***
						CASO 6:
							- Entro con idNotificacion en la url. /pendiente devuelve no devuelve nada. Todas las notificaciones estan firmadas, caducadas o canceladas. NO SE CONTEMPLA DENTRO DE ESTE CONDICIONAL
							- Redireccion a Gestor Documental ***OK***
						CASO 7:
							--Entro sin idNotificacion en la URL y firmo una 99,903 o 998. Debe poder generar correctamente el declaracion-responsable. Antes fallaba, ahora es ***OK***
						No se está seteando el idFirmaDocumento a la hora de subir un sol_documento y asociarlo. En el caso de abono si que se hace correctamente y se setea su idFirmaDocumento. No sabemos si para el resto de circuitos se debe hacer.

						POP-UP:
						CASO 1:
							--Accedemos sin idNotificacion en la url y esta todo cancelado, caducado, firmado. NO APARECE POP-UP ***OK***
						CASO 2:
							--Accedemos con idNotificacion en la url y esta caducada pero no esta firmada. DEBE APARECER POP-UP ***OK***
						CASO 3:
							--Accedemos con idNotificacion en la url y esta caducada pero SI esta firmada. NO DEBE APARECER POP-UP ***OK***
						*/

						// Para que entre en este if. Una notificación con idNotificacion en la url de tipo 99. idNotificacion98 !== idNotificacion99
						if (this.idNotificacionOrigen == null || notificacionPendiente !== this.idNotificacionOrigen) {
							this.$store.commit('solicitud/SET_ID_NOTIFICACION', notificacionPendiente);
							// Muestra la notificación pendiente, ya que el sistema de pendientes no está devolviendo otra notificación
							this.$router.push({ name: routeName, params: { id: target, notificacion: notificacionPendiente } });
						} else {
							this.$store.commit('solicitud/SET_ID_NOTIFICACION', this.idNotificacionOrigen);
							this.$router.push({
								name: routeName, params:
								{
									id: target,
									notificacion: this.idNotificacionOrigen
								}
							})
						}
					} else {
						this.compruebaNotificacionCaducada()
					}
				},
				error => {
					this.isLoading = false;
					this.$emit('alert-event', { text: 'Error al comprobar las notificaciones pendientes', color: 'red' });
					console.log(error);
				}
			);
		},

		compruebaNotificacionCaducada() {
			const idNotificacion = this.idNotificacionOrigen ? this.idNotificacionOrigen : -1
			api.compruebaNotificacionCaducada(idNotificacion,
				res => {
					this.isLoading = false;
					// Solo se muestra el pop up si la notificación está caducada y sin firmar
					if (res === true) {
						// Abre una ventana modal que notifica al usuario sobre la caducidad de la solicitud y le da la opción de acceder al gestor documental					
						this.$refs.dlgOkCancel.open();
					} else if (res === false) {
						this.redirectToDescargarDocumentacion()
					}
				},
				error => {
					this.isLoading = false;
					this.$emit('alert-event', { text: 'Error al comprobar la caducidad de la notificación', color: 'red' });
					console.log(error);
				}
			);
		},


		// Redirecciona al gestor documental
		redirectToDescargarDocumentacion() {
			this.$router.push({ name: 'descargar-documentacion', params: { id: this.usuario.token, notificacion: !this.idNotificacionOrigen ? -1 : this.idNotificacionOrigen } });
		}
	},
}
</script>